import { LegalDoc } from '../types';
import { termsDoc } from './terms';
import { privacyDoc } from './privacy';
import { communityGuidelinesDoc } from './communityGuidelines';
import { cookiesDoc } from './cookies';
import { paiaDoc } from './paia';

export const legalDocs: Record<string, LegalDoc> = {
  [termsDoc.slug]: termsDoc,
  [privacyDoc.slug]: privacyDoc,
  [communityGuidelinesDoc.slug]: communityGuidelinesDoc,
  [cookiesDoc.slug]: cookiesDoc,
  [paiaDoc.slug]: paiaDoc,
};

export const getLegalDoc = (slug: string | undefined): LegalDoc | undefined =>
  slug ? legalDocs[slug] : undefined;
